import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { PublicationImpactFactor, PublicationInfluence } from '@/module/Journal';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Abstract, AbstractRequest } from './AbstractTypes';

export function getAbstractImpactFactor(abstractId: Id) {
  return axios.get<PublicationImpactFactor>(`/author/abstracts/${abstractId}/impact-metrics`, {}).then(getData);
}

export function getAbstractInfluence(abstractId: Id) {
  return axios.get<PublicationInfluence>(`/author/abstracts/${abstractId}/influence-metrics`, {}).then(getData);
}

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Abstract>>('/author/abstracts/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Abstract>(`/author/abstracts/${id}`).then(getData);
}

export function edit(id: Id, request: AbstractRequest) {
  return axios.put<Abstract>(`/author/abstracts/${id}`, request).then(getData);
}

export function create(request: AbstractRequest) {
  return axios.post<Abstract>(`/author/abstracts`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/abstracts/${id}`).then(getData);
}

export function addNewAlias(abstractId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/abstracts/${abstractId}/add-new-alias`, request).then(getData);
}
